// Utils
import { API_FETCH_MAKER_LIST } from '../../../utils/API/apiUrls';

import { POST } from '../../../utils/fetchWrappers';

// API URLs

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as makerActions from './maker.actions';

// constants
import { FETCH_MAKER_LIST_REQUEST } from './maker.constants';

// Libs
import { takeLatest, put, call } from 'redux-saga/effects';
import moment from 'moment';
import { MOCK_API_VALUE } from 'utils/constants/commonValues';
import { makergetres } from 'mockApiWiseReqRes';

export function* fetchMakerDataList(actions) {
    yield put(makerActions.showLoader());
    try {
        const { payload } = actions;
        const res = {
            paging: {
                pageNumber: payload.pageIndex,
                pageSize: payload.pageSize,
            },
            dateRangeColumn: 'updated_on'
        };

        if (payload.createdOn) {
            res.startDateTime = moment(payload.createdOn.startDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            res.endDateTime = moment(payload.createdOn.endDate)
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            delete res.createdOn;
        }

        if (payload.rangeType) {
            res.dateRangeColumn = payload.rangeType;
        }

        let data;
        if (MOCK_API_VALUE) {
            data = makergetres();
        } else {
            const resp = yield call(POST, API_FETCH_MAKER_LIST, res);
            data = resp.data;
        }

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(makerActions.fetchMakerSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                makerActions.fetchMakerError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(makerActions.fetchMakerError({ error: data }));
    }
    yield put(makerActions.hideLoader());
}

export function* MakerSaga() {
    yield takeLatest(FETCH_MAKER_LIST_REQUEST, fetchMakerDataList);
}
